import React from "react";
import Alert from "react-bootstrap/Alert";

const ResponseAlert = ({ response, success, error }) => {
  if (!response) {
    return null;
  }
  const [errorResponse] = response;
  const variant = errorResponse ? "danger" : "success";
  const message = errorResponse?.response?.data?.message;
  const errorMessage = message ? message : error;
  return <Alert variant={variant} className="rounded-0">{errorResponse ? errorMessage : success}</Alert>;
};

ResponseAlert.defaultProps = {
  success: "Success!",
  error: "Something went wrong"
};

export { Alert, ResponseAlert };
